/**
 * Builds a local storage key for the given login id
 */
export function buildUserKey(loginId, key) {
    return `${loginId}.${key}`;
}
/**
 * Builds a local storage key for the given login id in hte specific user context
 */
export function buildUserContextKey(loginId, contextId, key) {
    return `${loginId}.${contextId}.${key}`;
}
